import { makeStyles } from '@material-ui/core';

export const useStyles = makeStyles(() => ({
  storeBoxes: {
    marginTop: '1.5rem',
  },
}));
